<app-add_user [isFromRegister]="true" ></app-add_user>